export default __webpack_public_path__ + "static/media/Tiger's Harness of the Primeval.a0315e88.jpg";